export const GalleryImages = [
  {
    url: "https://s3.us-east-2.amazonaws.com/tidepuertoescondio.com-assets/1.jpg",
  },
  // {
  //   url: "https://s3.us-east-2.amazonaws.com/tidepuertoescondio.com-assets/2.jpg",
  // },
  {
    url: "https://s3.us-east-2.amazonaws.com/tidepuertoescondio.com-assets/3.jpg",
  },
  {
    url: "https://s3.us-east-2.amazonaws.com/tidepuertoescondio.com-assets/4.jpg",
  },
  // {
  //   url: "https://s3.us-east-2.amazonaws.com/tidepuertoescondio.com-assets/5.jpg",
  // },
];
